import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaPython,
  FaDatabase,
  FaChartBar,
  FaGraduationCap,
  FaLightbulb,
  FaBriefcase,
  FaBook,
} from "react-icons/fa";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Link } from "react-router-dom";

const Dataanalytics = () => {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  const [faqOpen, setFaqOpen] = useState(Array(3).fill(false));
  const toggleFaq = (idx) => {
    const newState = [...faqOpen];
    newState[idx] = !newState[idx];
    setFaqOpen(newState);
  };

  const syllabus = [
    {
      title: "Module 1: Analytics Fundamentals",
      desc: "Learn core analytics concepts.",
      topics: [
        "Introduction to Analytics",
        "Data Types & Sources",
        "Statistics Basics",
        "Data Collection & Cleaning",
        "Tools Overview",
      ],
    },
    {
      title: "Module 2: Data Analysis & Visualization",
      desc: "Transform and visualize data effectively.",
      topics: [
        "Exploratory Data Analysis",
        "Data Transformation",
        "Charts & Graphs",
        "Storytelling with Data",
        "Dashboard Basics",
      ],
    },
    {
      title: "Module 3: Predictive Analytics",
      desc: "Build predictive models using data.",
      topics: [
        "Regression Analysis",
        "Classification Basics",
        "Model Evaluation",
        "Feature Selection",
        "Hands-on Projects",
      ],
    },
    {
      title: "Module 4: Tools & Applications",
      desc: "Hands-on with analytics tools.",
      topics: [
        "Python for Analytics",
        "SQL Queries",
        "Excel & Power BI",
        "Real-World Case Studies",
        "Capstone Project",
      ],
    },
  ];

  const tools = [
    {
      icon: <FaPython />,
      name: "Python",
      desc: "Programming for analytics.",
      color: "linear-gradient(135deg, #D0E8F2, #a0d2eb)",
    },
    {
      icon: <FaDatabase />,
      name: "SQL",
      desc: "Manage and query databases.",
      color: "linear-gradient(135deg, #FBE7C6, #f6c57f)",
    },
    {
      icon: <FaChartBar />,
      name: "Power BI",
      desc: "Create interactive dashboards.",
      color: "linear-gradient(135deg, #FFE2E2, #ff9a9e)",
    },
    {
      icon: <FaChartBar />,
      name: "Excel",
      desc: "Data analysis with spreadsheets.",
      color: "linear-gradient(135deg, #E2F0CB, #b4e197)",
    },
    {
      icon: <FaChartBar />,
      name: "Tableau",
      desc: "Visualize data effectively.",
      color: "linear-gradient(135deg, #E6E6FA, #cbbcf6)",
    },
  ];

  const learners = [
    {
      icon: <FaGraduationCap />,
      name: "Students",
      desc: "Enhance academic learning.",
      color: "linear-gradient(135deg,#F0E68C,#ffd36b)",
    },
    {
      icon: <FaBriefcase />,
      name: "Professionals",
      desc: "Boost career skills.",
      color: "linear-gradient(135deg,#D8BFD8,#c49dc9)",
    },
    {
      icon: <FaLightbulb />,
      name: "Analytics Enthusiasts",
      desc: "Learn data analytics for fun.",
      color: "linear-gradient(135deg,#B0E0E6,#8fd3f4)",
    },
    {
      icon: <FaGraduationCap />,
      name: "Researchers",
      desc: "Use analytics for studies.",
      color: "linear-gradient(135deg,#FFDAB9,#ffb085)",
    },
    {
      icon: <FaLightbulb />,
      name: "Career Changers",
      desc: "Switch to analytics careers.",
      color: "linear-gradient(135deg,#FFB6C1,#ff8fab)",
    },
  ];

  const careers = [
    {
      icon: <FaBriefcase />,
      title: "Data Analyst",
      desc: "Analyze datasets to provide actionable insights.",
      color: "linear-gradient(135deg,#FFF2E2,#ffd6a5)",
    },
    {
      icon: <FaBriefcase />,
      title: "Business Analyst",
      desc: "Bridge business and data insights effectively.",
      color: "linear-gradient(135deg,#E2F0FB,#a0d8ef)",
    },
    {
      icon: <FaBriefcase />,
      title: "Analytics Consultant",
      desc: "Advise companies on data strategies.",
      color: "linear-gradient(135deg,#FCE2E2,#f7a1a1)",
    },
    {
      icon: <FaBriefcase />,
      title: "BI Developer",
      desc: "Create dashboards and visualization reports.",
      color: "linear-gradient(135deg,#E2FBE2,#b7e4c7)",
    },
    {
      icon: <FaBriefcase />,
      title: "Data Scientist",
      desc: "Build predictive models using analytics techniques.",
      color: "linear-gradient(135deg,#F0E2FB,#cdb4f6)",
    },
    {
      icon: <FaBriefcase />,
      title: "Reporting Analyst",
      desc: "Design and generate analytical reports.",
      color: "linear-gradient(135deg,#FFF2E2,#ffd6a5)",
    },
  ];

  const outcomes = [
    {
      icon: <FaBook />,
      title: "Analyze Data",
      desc: "Understand datasets and extract insights.",
      color: "linear-gradient(135deg,#E2F0FB,#a0d8ef)",
    },
    {
      icon: <FaBook />,
      title: "Visualize Results",
      desc: "Create compelling charts and dashboards.",
      color: "linear-gradient(135deg,#FFE2E2,#f7a1a1)",
    },
    {
      icon: <FaBook />,
      title: "Build Models",
      desc: "Apply predictive analytics techniques.",
      color: "linear-gradient(135deg,#E6E6FA,#cbbcf6)",
    },
    {
      icon: <FaBook />,
      title: "Use Tools",
      desc: "Work with Python, SQL, Power BI, and Tableau.",
      color: "linear-gradient(135deg,#E2FBE2,#b7e4c7)",
    },
    {
      icon: <FaBook />,
      title: "Interpret Findings",
      desc: "Communicate insights to stakeholders.",
      color: "linear-gradient(135deg,#FFDAB9,#ffb085)",
    },
    {
      icon: <FaBook />,
      title: "Hands-on Projects",
      desc: "Apply skills in real-world projects.",
      color: "linear-gradient(135deg,#F0E68C,#ffd36b)",
    },
  ];

  const faq = [
    {
      question: "Do I need programming experience?",
      answer:
        "Basic understanding of Excel or SQL is helpful, but beginners are welcome.",
    },
    {
      question: "Which tools will I learn?",
      answer: "Python, SQL, Excel, Tableau, and Power BI.",
    },
    {
      question: "Is this course suitable for professionals?",
      answer:
        "Yes, it is designed for both students and working professionals.",
    },
  ];

  return (
    <div className="overflow-hidden">
      <style>{`
        body { font-family: 'Poppins', sans-serif; margin:0; padding:0; background:#f9f9fb; color:#333; }
        .container { width:90%; max-width:1200px; margin:auto; padding:2rem 0; }

        h2 { text-align:center; font-size:2.5rem; font-weight:bold; margin-bottom:2rem; }

        .cards { display:grid; gap:1.5rem; grid-template-columns: repeat(3,1fr); margin-bottom:3rem; }
        @media(max-width:992px) { .cards { grid-template-columns: repeat(2,1fr); } }
        @media(max-width:600px) { .cards { grid-template-columns: 1fr; } }

        .card { padding:2rem; border-radius:20px; color:#222; text-align:center;
          background:#fff; box-shadow:0 8px 25px rgba(0,0,0,0.1); transition:0.4s; backdrop-filter: blur(10px); }
        .card:hover { transform: translateY(-8px) scale(1.03); box-shadow:0 15px 30px rgba(0,0,0,0.2); }
        .card h3 { margin:0.8rem 0; font-size:1.3rem; font-weight:bold; }
        .card p { font-size:0.95rem; margin-bottom:0.5rem; }

        .icon-circle { width:60px; height:60px; display:flex; align-items:center; justify-content:center;
          margin:auto; border-radius:50%; background:rgba(255,255,255,0.5); font-size:1.8rem; margin-bottom:10px; }

        .faq-card { background:#fff; padding:1rem 1.5rem; border-radius:15px; margin-bottom:1rem;
          box-shadow:0 5px 15px rgba(0,0,0,0.1); transition:0.3s; }
        .faq-card:hover { transform: translateY(-3px); }
        .faq-header { display:flex; justify-content:space-between; align-items:center; cursor:pointer; }
        .faq-answer { max-height:0; overflow:hidden; transition:max-height 0.3s ease; }
        .faq-answer.open { max-height:300px; margin-top:0.5rem; }
      `}</style>

      {/* Hero Section */}
      <header
        className="hero-section"
        style={{
          background:
            "linear-gradient(to right, rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('/assets/data-analytics-business-intelligence-concept_31965-6463.jpg') center/cover no-repeat",
          color: "#fff",
          textAlign: "center",
          padding: "7rem 1rem",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
        data-aos="fade-down"
      >
        <h1
          style={{
            fontSize: "3rem",
            fontWeight: "700",
            marginBottom: "1rem",
            textShadow: "2px 2px 10px rgba(0,0,0,0.5)",
          }}
        >
          Master Data Analytics
        </h1>
        <p
          style={{
            fontSize: "1.3rem",
            maxWidth: "700px",
            marginBottom: "2rem",
            lineHeight: "1.6",
          }}
        >
          Learn modern data analytics techniques, tools, and visualization
          skills. Transform raw data into actionable insights and drive business
          decisions.
        </p>
        <Link
          to="/contact"
          className="btn"
          style={{
            background: "#6c5ce7",
            color: "#fff",
            padding: "0.8rem 2rem",
            borderRadius: "30px",
            fontWeight: 600,
            textDecoration: "none",
            transition: "0.3s",
          }}
          onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
        >
          Enroll Now
        </Link>
      </header>

      {/* About */}
      <section className="about-course flex flex-col md:flex-row items-center gap-8 py-12 px-4 md:px-12">
        {/* Text content */}
        <div
          className="about-content flex-1 text-justify"
          data-aos="fade-right"
        >
          <h2 className="text-2xl md:text-3xl font-semibold mb-6 text-center md:text-left text-black">
            About This Data Analytics Course
          </h2>
          <p className="mb-4">
            This course is designed to give you a strong foundation in the world
            of Data Analytics. You’ll start by understanding the fundamentals of
            data collection, cleaning, and visualization, and gradually move to
            advanced analytics techniques used in the industry.
          </p>
          <p className="mb-4">
            You will gain hands-on experience with Python, SQL, Excel, Power BI,
            and Tableau while working on real-world case studies. The course
            emphasizes the importance of interpreting data accurately and
            presenting insights clearly to stakeholders.
          </p>
          <p>
            By the end of this course, you will be confident in analyzing large
            datasets, building dashboards, and applying data-driven
            decision-making to solve business problems and support strategic
            planning.
          </p>
        </div>

        {/* Image */}
        <img
          src="/assets/istockphoto-1488294044-612x612.jpg"
          alt="Data Analytics"
          className="w-full md:w-3/5 max-w-md rounded-xl shadow-lg"
          data-aos="fade-left"
        />
      </section>

      {/* Syllabus */}
      <section className="py-16 max-w-6xl mx-auto px-6" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-center mb-12">
          Course Syllabus
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {syllabus.map((mod, idx) => {
            const syllabusColors = ["#ff9800", "#4caf50", "#2196f3", "#e91e63"];
            const color = syllabusColors[idx % syllabusColors.length];

            return (
              <div
                key={idx}
                className="relative p-6 bg-white border rounded-xl shadow-md hover:shadow-lg transition transform hover:scale-105 animate-shake"
                data-aos="fade-up"
                data-aos-delay={idx * 100}
              >
                {/* Gradient corner top-left */}
                <div
                  className="corner-accent"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "40px",
                    height: "40px",
                    borderTopLeftRadius: "12px",
                    background: `linear-gradient(135deg, ${color}, transparent)`,
                    boxShadow: `0 0 8px ${color}`,
                  }}
                ></div>

                {/* Icon */}
                <div
                  className="icon-circle flex justify-center items-center mb-4"
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    border: `2px solid ${color}`,
                    margin: "0 auto",
                    fontSize: "1.8rem",
                    color: color,
                  }}
                >
                  <FaBook />
                </div>

                {/* Title */}
                <h3 className="text-xl font-semibold text-center mb-3">
                  {mod.title}
                </h3>

                {/* Description */}
                {mod.desc && (
                  <p className="text-gray-700 text-center mb-3">{mod.desc}</p>
                )}

                {/* Topics */}
                <ul className="text-gray-600 list-disc list-inside text-left">
                  {mod.topics.map((t, i) => (
                    <li key={i}>{t}</li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </section>

      {/* Tools */}
      <section className="container" data-aos="fade-up">
        <h2>Tools & Technologies</h2>
        <div className="cards animate-float">
          {tools.map((tool, idx) => (
            <div
              className="card "
              key={idx}
              style={{ background: tool.color }}
              data-aos="flip-left"
              data-aos-delay={idx * 50}
            >
              <div className="icon-circle animate-bounce-slow">{tool.icon}</div>
              <h3>{tool.name}</h3>
              <p>{tool.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Learners */}
      <section className="container" data-aos="fade-up">
        <h2>Who Can Enroll</h2>
        <div className="cards animate-pulse">
          {learners.map((learner, idx) => (
            <div
              className="card"
              key={idx}
              style={{ background: learner.color }}
              data-aos="fade-right"
              data-aos-delay={idx * 50}
            >
              <div className="icon-circle animate-wiggle">{learner.icon}</div>
              <h3>{learner.name}</h3>
              <p>{learner.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Careers */}
      <section className="container" data-aos="fade-up">
        <h2>Career Opportunities</h2>
        <div className="cards">
          {careers.map((career, idx) => (
            <div
              className="card animate-float"
              key={idx}
              style={{ background: career.color }}
              data-aos="fade-left"
              data-aos-delay={idx * 50}
            >
              <div className="icon-circle animate-wiggle">{career.icon}</div>
              <h3>{career.title}</h3>
              <p>{career.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Outcomes */}
      <section className="container py-16" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-center mb-12">
          What You'll Learn
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {outcomes.map((outcome, idx) => (
            <div
              key={idx}
              className="card zoom-animation relative p-6 rounded-xl shadow-md text-center"
              style={{ background: outcome.color }}
              data-aos="zoom-in"
              data-aos-delay={idx * 50}
            >
              <div
                className="icon-circle flex justify-center items-center mb-4"
                style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  border: "2px solid black",
                  margin: "0 auto",
                  fontSize: "1.8rem",
                  color: "black",
                }}
              >
                {outcome.icon}
              </div>
              <h3 className="text-xl font-semibold mb-2">{outcome.title}</h3>
              <p className="text-gray-900">{outcome.desc}</p>
            </div>
          ))}
        </div>

        {/* Animation CSS */}
        <style>{`
    .zoom-animation {
      animation: zoomInOut 4s ease-in-out infinite;
    }

    @keyframes zoomInOut {
      0%, 100% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.05);
      }
    }
  `}</style>
      </section>

      {/* FAQ */}
      <section
        className="container py-16"
        data-aos="fade-up"
        style={{
          background: "#f0f4f8",
          padding: "4rem 1rem",
          borderRadius: "20px",
        }}
      >
        <h2
          className="text-3xl font-bold text-center mb-12"
          style={{ color: "#1a202c" }}
        >
          Frequently Asked Questions
        </h2>
        {faq.map((q, idx) => (
          <div
            key={idx}
            className="faq-card"
            style={{
              background: "#fff",
              borderLeft: "4px solid #6c5ce7",
              padding: "1.5rem",
              borderRadius: "12px",
              marginBottom: "1rem",
              boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
              transition: "0.3s",
            }}
          >
            <div
              className="faq-header flex justify-between items-center cursor-pointer"
              onClick={() => toggleFaq(idx)}
              style={{ color: "#1a202c", fontWeight: 500 }}
            >
              <h3>{q.question}</h3>
              {faqOpen[idx] ? <FaChevronUp /> : <FaChevronDown />}
            </div>
            <div
              className={`faq-answer ${faqOpen[idx] ? "open" : ""}`}
              style={{
                maxHeight: faqOpen[idx] ? "300px" : "0",
                overflow: "hidden",
                transition: "max-height 0.3s ease",
                marginTop: faqOpen[idx] ? "0.5rem" : "0",
                color: "#4a5568",
              }}
            >
              <p>{q.answer}</p>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default Dataanalytics;
